<template>
    <v-dialog v-model="dialog" width="1300" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-card title="Basic Information" elevation="4">
                                <v-card-text>
                                    <v-divider></v-divider>
                                    <v-row class="mt-2">
                                        <v-col cols="12" md="2">
                                            <div class="font-weight-bold">First Name:</div>
                                            <div>{{ userDetails?.fname }}</div>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <div class="font-weight-bold">Middle Name:</div>
                                            <div>{{ userDetails?.mname }}</div>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <div class="font-weight-bold">Last Name:</div>
                                            <div>{{ userDetails?.lname }}</div>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <div class="font-weight-bold">Suffix:</div>
                                            <div>{{ userDetails?.suffix }}</div>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <div class="font-weight-bold">Post Nominal:</div>
                                            <div>{{ userDetails?.post_nominal }}</div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <div class="font-weight-bold">Bachelor's Degree:</div>
                                            <div>{{ userDetails?.undergraduate }}</div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <div class="font-weight-bold">Master's Degree:</div>
                                            <div>{{ userDetails?.graduate }}</div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <div class="font-weight-bold">Doctoral/Professional Degree:</div>
                                            <div>{{ userDetails?.post_graduate }}</div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <div class="font-weight-bold">Designation for Document Signatory:</div>
                                            <div>{{ userDetails?.designation ? userDetails?.designation : '---' }}</div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card title="Academic Information" elevation="4">
                                <v-card-text>
                                    <v-divider></v-divider>
                                    <v-row class="mt-2">
                                        <v-col cols="12" md="4">
                                            <div class="font-weight-bold">Employment Status:</div>
                                            <div>{{ userDetails?.employmentStatus?.description }}</div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <div class="font-weight-bold">Academic Rank:</div>
                                            <div>{{ userDetails?.academicRank?.description }}</div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <div class="font-weight-bold">Office:</div>
                                            <div>{{ userDetails?.office?.name }}</div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <div class="font-weight-bold">Program:</div>
                                            <div>{{ userDetails?.program?.name }}</div>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <div class="font-weight-bold">Position</div>
                                            <div>{{ userDetails?.position?.name }}</div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card title="Role Management" elevation="4">
                                <v-card-text>
                                    <v-divider></v-divider>
                                    <v-row class="mt-2">
                                        <v-col cols="12" md="4">
                                            <v-select
                                            v-model="roles"
                                            clearable
                                            chips
                                            variant="outlined"
                                            :rules="[formRules.required]"
                                            label="Role"
                                            color="darkGreen"
                                            :items="roleData"
                                            item-title="name"
                                            item-value="id"
                                            multiple
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Verify" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            userDetails: [],
            roleData: [],

            roles: null,
        }
     },
     methods: {
        init(data){
            this.dialog = true
            this.dialog_title = 'Account Verification'
            this.dialog_sub_title = 'Accounts must be carefully reviewed before given a role and be verified'

            this.userDetails = data

            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/roles',
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.roleData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                let formData = {
                    id: this.userDetails.id,
                    roles: JSON.stringify(this.roles),
                    verifierId: this.$store.state.user.id
                }

                const token = localStorage.getItem('aums-token')
                axios.patch(process.env.VUE_APP_SERVER_URL + '/user-details/verifyUser', formData,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data.status == 200){
                        this.$emit('refresh')
                        this.loading = false
                        showSnackbar('Account Succesfully Verified!')
                        this.$refs.form.reset()
                        this.dialog = false
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false
                        showSnackbar('Token expired! Logging out..')

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                });
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.$emit('refresh')
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>